import { useSelector } from 'react-redux';

import { EntityBlockedReasonsResponse } from 'app/modules/entities/responses';
import { selectHasReadEntitiesPermissions } from 'app/modules/session/selectors';

import { ENTITY_QUERY_KEYS } from 'app/modules/entities/queries/keys';

import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';

export const useGetBlockedReasons = (entityExternalId: string) => {
  const hasReadEntitiesPermission = useSelector(
    selectHasReadEntitiesPermissions,
  );
  return useQuery({
    queryFn: () =>
      get<EntityBlockedReasonsResponse>(
        `/v1/entities/${encodeURIComponent(entityExternalId || '')}/entity-blocked-reasons`,
      ),
    queryKey: ENTITY_QUERY_KEYS.getEntityBlockedReasons(entityExternalId),
    staleTime: 10000,
    enabled: hasReadEntitiesPermission && !!entityExternalId,
  });
};
